import { get, set } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import { mapState } from 'vuex';
export default {
  name: 'HeatmapChartOptionsEditor',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    valueDeterminations() {
      const determinations = ['min', 'max', 'average', 'sum', 'earliest', 'latest'];
      return determinations.map(determination => ({
        text: this.$t(`Dashboards.components.widgetChartOptionsEditor.inputs.heatmap.valueDetermination.values.${determination}`),
        value: determination
      }));
    }
  },
  methods: {
    getByKey(key, defaultValue = undefined) {
      return get(this.value, key, defaultValue);
    },
    setByKey(key, value, valueTransformTo = undefined) {
      const clonedValue = cloneDeep(this.value);
      if (valueTransformTo === 'number') {
        value = Number(value);
      }
      set(clonedValue, key, value);
      this.$emit('input', clonedValue);
    }
  }
};